export function viewErrorCount(field, data, viewFilter) {
  let newData = [...data];

  if (viewFilter.includes('none') && !viewFilter.includes('hasErrors')) {
    newData = data.filter((item) => !item[field]);
  } else if (viewFilter.includes('hasErrors') && !viewFilter.includes('none')) {
    newData = data.filter((item) => item[field]);
  }

  return [...newData];
}
